export default "__VITE_ASSET__kLCdQHGF__"